app.service('operatorMaxWorthCalculator', function (orderConfig, price, localStorage, cookie, front) {
	var $self, config, $errorLowRate, $errorOverMaxRate, $clientMaxInstalmentWorth;
	var cartCookie = cookie.get(front.euro ? 'euroCart' : 'oleoleCart');

	const localStorageName = 'max-instalment';
	function setEvents() {
		config = orderConfig.getData();
		if (config.maxWorthInstalmentCalculatorData) {
			$clientMaxInstalmentWorth = $('#client-max-instalment-worth', $self);
			$remainingWorth = $('#remaining-worth', $self);
			$errorLowRate = $('#error-low-rate', $self);
			$errorOverMaxRate = $('#error-over-max-rate', $self);
			$clientMaxInstalmentWorth.on('input', function () {
				changeIstalment();
			}).on('blur', function () {
				saveValue();
			});
			checkSaved();
		}
	}
	function checkSaved() {
		let localValue = localStorage.getItem(localStorageName);
		if (localValue && localValue.indexOf(':') > 0) {
			localValue = localValue.split(":");
			if (localValue[0] === cartCookie) {
				if (localValue[1]/1 > 0) {
					$clientMaxInstalmentWorth.val(localValue[1]);
					changeIstalment();
				} else {
					localStorage.removeItem(localStorageName);
				}
			} else {
				localStorage.removeItem(localStorageName);
			}
		} else {
			localStorage.removeItem(localStorageName);
		}
		
	}
	function saveValue() { 
		localStorage.setItem(localStorageName, cartCookie+':'+$clientMaxInstalmentWorth.val());
	}
	function changeIstalment() {
		var value = $clientMaxInstalmentWorth.val();
		var newValue = parseInt(value * 100) / 100;
		if (newValue > 0) {
			let remainingWorth = (newValue * config.maxWorthInstalmentCalculatorData.instalmentNumber) - config.maxWorthInstalmentCalculatorData.cartWorth;
			$errorOverMaxRate.hide();
			$remainingWorth.val(price.format(remainingWorth));
			if (newValue * config.maxWorthInstalmentCalculatorData.instalmentNumber > config.maxWorthInstalmentCalculatorData.maxCartWorth) {
				$errorOverMaxRate.show();
			} else if (remainingWorth > 0) {
				$errorLowRate.hide();
			} else {
				$errorLowRate.show();
			}
		} else {
			$clientMaxInstalmentWorth.val('');
		}
	}
	function init() {
		$self = $('#operator-max-worth-calculator');
		if ($self.length) {
			setEvents();
		} else {
			localStorage.removeItem(localStorageName);
		}
	}
	return {
		init
	};
});
